import React, { RefObject } from 'react';
import { Button, Input } from '@ui';
import IconImageUpload from '@icons/Icons/IconImageUpload';

// Defaults used when parent doesn't provide explicit limits
const DEFAULT_MAX_FILES = 10;
const DEFAULT_MAX_MB = 10;

interface ImageUploaderDropzoneProps {
  fileInputRef: RefObject<HTMLInputElement>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDrop?: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragOver?: (e: React.DragEvent<HTMLDivElement>) => void;
  /** Optional limits for UI hinting */
  maxFiles?: number;
  maxMB?: number;
}

const ImageUploaderDropzone: React.FC<ImageUploaderDropzoneProps> = ({
  fileInputRef,
  handleInputChange,
  handleDrop,
  handleDragOver,
  maxFiles = DEFAULT_MAX_FILES,
  maxMB = DEFAULT_MAX_MB,
}) => (
  <div
    className='card dropzone'
    id='dropzone'
    aria-label='Image upload dropzone'
    onDrop={handleDrop}
    onDragOver={handleDragOver}
  >
    <Input
      id='fileInput'
      type='file'
      accept='image/*'
      multiple
      style={{ display: 'none' }}
      ref={fileInputRef}
      onChange={handleInputChange}
    />
    <div className='dropzone-inner'>
      <Button className='btn-icon' icon={<IconImageUpload />} />
      <b>Drop images here</b>
      <div className='hint'>
        or click to — up to {maxFiles} files, max {maxMB} MB each
      </div>
    </div>
  </div>
);

export default ImageUploaderDropzone;
